import { Loader } from "@crunchyroll/cx-web-components";

import styles from "./CommentsLoader.module.scss";

const CommentsLoader = () => (
  <div className={styles.commentsLoader}>
    <Loader size="l" hasPadding={false} />
  </div>
);

export default CommentsLoader;
